import { SubmissionError } from 'redux-form';

import { user } from 'services';
import { LangSelector } from 'libs/ui';
import { LoginForm } from './form';
import { Content } from './index.styled';

export const Auth = () => {
  /**
   * login
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    return user.login(values).catch((error) => {
      throw new SubmissionError({
        _error: error,
      });
    });
  };

  return (
    <Content>
      <img src="/images/auth-logo.png" alt="CLEVER PARK" />
      <LangSelector />
      <LoginForm onSubmit={submit} />
    </Content>
  );
};
